import Layout from "../components/Layout";
import { PvcTransactions } from "../components/_PVCTransaction";

const PvcTransactionPage = (props:any) => {
    return (
    <Layout>
        <PvcTransactions/>
    </Layout>
    )
}

export default PvcTransactionPage